import React from "react";
import {
  createBrowserRouter,
  createHashRouter,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import { isAuthenticated } from "../utils/AuthGuard";
import Dashboard from "../views/dashboard/Dashboard";
import Login from "../views/login/Login";
import NotFound from "../views/404/NotFound";
import Utilisateurs from "../views/utilisateurs/Utilisateurs";
import Identifiants from "../views/identifiants/Identifiants";
import Paiement from "../views/paiement/Paiement";
import Tarifs from "../views/tarifs/Tarifs";
import NiveauEtude from "../views/niveau-etude/NiveauEtude";
import Eleves from "../views/eleves/Eleves";
import ModalitePaiement from "../views/modalite-paiement/ModalitePaiement";
import AnneeScolaire from "../views/annee-scolaire/AnneeScolaire";
import CanalPaiement from "../views/canal-paiement/CanalPaiement";
import Entite from "../views/entite/Entite";
import DashboardChurch from "../views/dashboard-church/Dashboard";
import DashboardHotel from "../views/dashboard-hotel/Dashboard";
import UtilisateursEntite from "../views/utilisateurs-entite/UtilisateursEntite";
import IdentifiantsEntite from "../views/identifiants-entite/IdentifiantsEntite";
import SousEntite from "../views/sous-entite/SousEntite";
import ForgetPassword from "../views/forget-password/ForgetPassword";
import Caissiere from "../views/caissiere/caissiere";
import CliniquePaiement from "../views/cliniquePaiement/CliniquePaiement";

const ProtectedRoute = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" />;
};

const RedirectedRoute = () => {
  const routeParam = useParams();
  localStorage.setItem("entiteRoute", routeParam.entiteUrl);
  return <Navigate replace to="/sous-entites" />;
};

const Router = createHashRouter(
  [
    {
      path: "*",
      element: <NotFound />,
    },
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/forget-password",
      element: <ForgetPassword />,
    },
    {
      path: "/paiement-clinique/:code",
      element: <CliniquePaiement />,
    },
    {
      path: "/",
      element: <Navigate replace to="/entites" />,
    },
    {
      path: "/",
      element: <ProtectedRoute />,
      children: [
        {
          path: "/entites",
          element: <Entite />,
        },
        {
          path: "/sous-entites",
          element: <SousEntite />,
        },
        {
          path: "/utilisateurs",
          element: <UtilisateursEntite />,
        },
        {
          path: "/identifiants",
          element: <IdentifiantsEntite />,
        },
      ],
    },
    {
      path: ":entiteUrl",
      element: <ProtectedRoute />,
      children: [
        {
          path: "/:entiteUrl",
          element: <RedirectedRoute />,
        },
        {
          path: "/:entiteUrl/entite/dashboard",
          element: <Dashboard />,
        },
        {
          path: "/:entiteUrl/entite/church/dashboard",
          element: <DashboardChurch />,
        },
        {
          path: "/:entiteUrl/entite/hotel/dashboard",
          element: <DashboardHotel />,
        },
        {
          path: "/:entiteUrl/entite/utilisateurs",
          element: <Utilisateurs />,
        },
        {
          path: "/:entiteUrl/entite/caissieres",
          element: <Caissiere />,
        },
        {
          path: "/:entiteUrl/entite/identifiants",
          element: <Identifiants />,
        },
        {
          path: "/:entiteUrl/entite/niveau-etude",
          element: <NiveauEtude />,
        },
        {
          path: "/:entiteUrl/entite/tarifs",
          element: <Tarifs />,
        },
        {
          path: ":entiteUrl/entite/tarifs/modalite-paiement",
          element: <ModalitePaiement />,
        },
        {
          path: "/:entiteUrl/entite/eleves",
          element: <Eleves />,
        },
        {
          path: "/:entiteUrl/entite/annee-scolaire",
          element: <AnneeScolaire />,
        },
        {
          path: "/:entiteUrl/entite/paiement",
          element: <Paiement />,
        },
        {
          path: "/:entiteUrl/entite/canal-paiement",
          element: <CanalPaiement />,
        },
      ],
    },
  ]
  // { basename: "/servicemomo-etablissement" }
);

export default Router;
